import React from 'react'
import styles from './ConfirmDialog.module.css'

const ConfirmDialog = ({ text, error, busy, confirmText = 'Да', cancelText = 'Нет', onConfirm, onCancel }) => (
  <div className={styles.overlay} onClick={busy ? undefined : onCancel}>
    <div className={styles.dialog} onClick={e => e.stopPropagation()}>
      <p className={styles.text}>{text}</p>
      {error && <p className={styles.error}>Не удалось удалить, попробуйте ещё раз</p>}
      <div className={styles.buttonRow}>
        <button className={styles.confirm} onClick={onConfirm} disabled={busy}>
          {confirmText}
        </button>
        <button className={styles.cancel} onClick={onCancel} disabled={busy}>
          {cancelText}
        </button>
      </div>
    </div>
  </div>
)

export default ConfirmDialog
